import React, { createRef, useRef, useEffect } from 'react';

import useUI from 'hooks/use-ui';

const cartButtonRef = createRef<HTMLButtonElement>();
const globalHeaderRef = createRef<HTMLDivElement>();

export type GlobalHeaderRefs = {
  cartButtonRef: typeof cartButtonRef;
  globalHeaderRef: typeof globalHeaderRef;
  addressDropdownContainerRef: React.MutableRefObject<HTMLDivElement | undefined>;
  shopDropdownContainerRef: React.MutableRefObject<HTMLDivElement | undefined>;
};

export function useGlobalHeaderRefs(): GlobalHeaderRefs {
  const UI = useUI();

  const addressDropdownContainerRef = useRef<HTMLDivElement>();
  const shopDropdownContainerRef = useRef<HTMLDivElement>();

  useEffect(() => {
    UI.setCartButtonRef(cartButtonRef);
    return () => UI.clearCartButtonRef();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [UI, cartButtonRef]); // FIXME: ENG-32714 fix hooks dependency

  return {
    cartButtonRef,
    globalHeaderRef,
    addressDropdownContainerRef,
    shopDropdownContainerRef,
  };
}
